// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgStarHalfIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m12 3.5 2.06 6h6.44l-5.17 3.69 2.17 6.31-5.5-3.93zM12 2c-.64 0-1.21.41-1.42 1.01L8.87 8H3.5c-.65 0-1.23.42-1.43 1.04s.03 1.3.56 1.68l4.26 3.04-1.8 5.25A1.505 1.505 0 0 0 6.51 21c.32 0 .61-.09.87-.28l4.63-3.31 4.63 3.31c.26.19.57.28.87.28s.63-.1.9-.3c.52-.39.73-1.07.52-1.69l-1.8-5.25 4.26-3.04c.53-.38.76-1.06.56-1.68S21.17 8 20.52 8h-5.37l-1.71-4.99C13.23 2.4 12.66 2 12.02 2z" />
  </g>
);
export default SvgStarHalfIcon;
SvgStarHalfIcon.displayName = 'SvgStarHalfIcon';
